import React from "react";
import MDEditor from "@uiw/react-md-editor";

export function MarkdownField({
                                  title = "Waiver text",
                                  description = "Shown during checkout. Keep it clear and specific.",
                                  value,
                                  onChange,
                              }: {
    title: string;
    description?: string;
    value: string;
    onChange: (v: string) => void;
}) {
    return (
        <div>
            <label className="block text-sm font-medium text-gray-900 mb-1">
                {title}
            </label>
            <p className="text-xs text-gray-500 mb-2">
                {description}
            </p>
            <div data-color-mode="light">
                <MDEditor
                    value={value}
                    onChange={(v) => onChange(v ?? "")}
                    height={400}
                    preview="edit"
                />
            </div>
        </div>
    );
}